export const FETCH_REFERAL_INFO = "FETCH_REFERAL_INFO"
export const FETCH_REFERAL_INFO_SUCCESS = "FETCH_REFERAL_INFO_SUCCESS"

